import styled from "@emotion/styled";

export const UploadedFilesContainer = styled.div`
  overflow-y: auto;
`;

export const UploadedFileItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border: 2px dotted #6860ee;
  border-radius: 8px;
`;

export const FileNameContainer = styled.span`
  font-size: 14px;
  color: var(--header__color);
  flex-grow: 1;
  margin-right: 8px;
  word-break: break-word;
`;

export const DeleteIconDiv = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  svg {
    width: 20px;
    height: 20px;
    fill: #d32f2f;
    transition: transform 0.2s;
  }

  &:hover svg {
    transform: scale(1.1);
  }
`;

export const TrackingMainContainer = styled("div")({
  height: "auto",
  "@media screen and (max-width:1220px)": {
    padding: "10px",
  },
});

export const TrackingUpperOuterContainer = styled("div")({
  borderRadius: "10px",
});

export const TrackingUpperContainer = styled("div")({
  display: "flex",
  marginTop: "10px",
  flexDirection: "column",
});

export const DocumentLeftContainer = styled("div")({
  margin: 0,
  width: "100%",
  display: "flex",
  flexDirection: "row",
  gap: "20px",
  "@media screen and (max-width:1220px)": {
    gap: "10px",
    flexDirection: "column",
  },
});

export const FileDropMainContainer = styled("div")({
  width: "70%",
  "@media screen and (max-width:1220px)": {
    width: "100%",
  },
});

export const FileDropContainer = styled("div")(({ isDragging }) => ({
  padding: "30px 50px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  border: isDragging ? "2px dashed #0055a5" : "2px dashed #ccc",
  borderRadius: "16px",
  cursor: "pointer",
}));

export const FileDropMessage = styled("p")({
  fontSize: "12px",
  fontWeight: "400",
  color: "var(--header__color)",
});

export const NoteListContainer = styled("ul")({
  margin: 0,
});

export const NoteList = styled("li")({
  margin: 0,
  fontSize: "12px",
  fontWeight: "400",
  color: "var(--header__color)",
  lineHeight: "20px",
  "&::marker": {
    color: "#6860EE",
  },
});

export const DocumentRightContainer = styled("div")({
  margin: 0,
  display: "flex",
  flexDirection: "column",
});

export const DocumentDescription = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "60px",
  marginTop: "40px",
  justifyContent: "center",
  width: "100%",
  "@media screen and (max-width:1200px)": {
    flexDirection: "column",
    gap: "0px",
  },
});

export const StyledDocumentaButtonDiv = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
  "@media screen and (max-width:1200px)": {
    width: "100%",
    justifyContent: "center",
  },
});

export const DocumentMainInnerContainer = styled("div")({
  width: "100%",
  padding: "10px 0px",
});

export const ContentDocumentContainer = styled("div")({
  border: "0.5px solid var(--border__color)",
  borderRadius: "12px",
  transition: "border-color 0.15s, background 0.15s",
  "&:hover": {
    borderColor: "#534AB7",
    background: "#EEEDFE22",
  },
});

export const ContentDocumentDescription = styled("div")({
  display: "flex",
  flexDirection: "row",
  padding: "14px 16px",
  borderRadius: "12px",
  alignItems: "center",
  gap: "14px",
});

export const PdfIcon = styled("img")({
  margin: 0,
  width: "25px",
  height: "25px",
  marginRight: "20px",
  paddingTop: "5px",
});

export const ContentItems = styled("div")({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  justifyContent: "space-between",
});

export const ContentHeading = styled("h5")({
  margin: 0,
  marginBottom: "10px",
  color: "#6860EE",
  marginTop: "10px",
});

export const DocumentHeading = styled("h3")({
  fontsize: "20px",
  fontWeight: "500",
  colors: "#000000",
  margin: "0",
  marginBottom: "20px",
  marginTop: "20px",
});
export const StyledFileTailContents = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "5px",
});
